import styled from "styled-components";
import { colors } from "../../../../assets";

export const CalendarBoxContainer = styled.div`
  z-index: 9;
  position: relative;
  min-width: 150px;

  input {
    width: 100%;
    height: 48px;
    border: 1px solid #dcdcdc;
    background-color: #fff;
    border-radius: 4px;
    font-size: 16px;
    padding: 0 10px;
    color: #004a8f;
    transition: background-color 0.2s ease;
    appearance: none;
    font-weight: 500;

    &:focus {
      border: 1px solid #004a8f;
      outline: none;
    }

    &:hover {
      background-color: rgba(159, 159, 159, 0.1);
    }
  }

  &.show-calendar {
    z-index: 12;
    .input-box-main-field {
      background: #ffffff;
      box-shadow: var(--box-shadow);
      outline: none;
      border-bottom: none;
    }
    .calendar-popup {
      display: block;
    }
  }

  &.required {
    .input-box-main-field {
    }
  }

  &.disabled {
    pointer-events: none;

    .input-box-topbar-label {
      color: ${colors["TX-001-30"]};
    }

    .input-box-main-field {
      background: ${colors["FL-001-Disabled"]};

      input {
        color: ${colors["TX-001-30"]};
      }

      &:before {
        background: ${colors["TX-001-30"]};
      }
    }
  }

  .input-box-topbar {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 9;
  }

  .input-box-topbar-label {
    color: ${colors["PR-001-50"]};
    text-transform: uppercase;
  }

  .input-box-topbar-icon {
    position: relative;
    z-index: 9;
    display: inherit;
    img {
      width: 24px;
      cursor: pointer;
    }
  }

  .input-box-main-field {
    p {
      cursor: inherit;
    }

    &:hover {
      background: #f0fafd;
    }

    &:focus {
      background: #ffffff;
      box-shadow: var(--box-shadow);
      outline: none;
      border-bottom: none;
    }
  }

  .input-box-icon {
    position: absolute;
    top: 10px;
    right: 16px;
    width: 24px;

    img {
      width: 25px;
      cursor: pointer;
    }
    &.cross {
      right: 50px;
    }
  }

  .calendar-popup {
    position: absolute;
    ${(props) => (props.alignPopupLeft ? "left: -50px" : "right: 0px")};
    border-radius: 3px;
    box-shadow: var(--box-shadow);
    z-index: 40;
    display: none;
    color: ${colors["PR-001-100"]};

    li {
      transition: 0.3s all ease-in-out;
      cursor: pointer;
      padding: 11px 13px;
      width: 100%;

      &:hover {
        background: #f0fafd;
      }
    }
  }

  .input-box-error {
    color: ${colors["ER-001-100"]};
    padding-top: 3px;

    p {
      color: ${colors["ER-001-100"]};
    }
  }

  &.error {
    .input-box-main-field > input,
    textarea {
      border: 1px solid ${colors["ER-001-100"]};
      &::placeholder {
        color: ${colors["ER-001-100"]};
      }
    }

    input {
      border-color: ${colors["ER-001-100"]};
    }
  }
`;
